import React, { createContext, useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

const BrandingContext = createContext();

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within a BrandingProvider');
  }
  return context;
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadBranding = async () => {
      try {
        // Try to load custom branding first
        const response = await fetch('/branding.json');
        if (response.ok) {
          const data = await response.json();
          setBranding(data);
          return;
        }
      } catch (err) {
        setError('Failed to load branding configuration');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadBranding();
  }, []);
  return <BrandingContext.Provider value={{ branding, loading, error }}>{children}</BrandingContext.Provider>;
};

BrandingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
